// Konfiguration der Produktfilter und Bildauflösungsstufen
// Die Definition meint immer dpi kleiner als der angegebene Wert
// grüßer/gleich good ist perfect
// Beispiel: dpi < 150 -> notRecommended, dpi < 225 -> low, dpi < 300 -> good, dpi >= 300 -> perfect

const imageResolutionLevels = {
    notRecommended: 150,
    low: 225,
    good: 300,
};

// Zeige eine vom Nutzer zu bestätigende Warnung, wenn die Bildauflösung unterhalb eines bestimmten Levels liegt
const resolutionConfirmation = { enabled: true, fromLevel: 'notRecommended' };

const specialPriceDisplay = { enabled: true };

const previewResourceSizes = {
    thumbnail: 240,
    gallery: 1200,
};

const filterDef = {
    pgrId: {
        1: { name: "photos", label: "Fotos", labelSingular: "Foto" },
        2: { name: "grusskarten", label: "Postkarte mit Text", labelSingular: "Postkarte mit Text" },
        3: { name: "postkarten", label: "Postkarte", labelSingular: "Postkarte" },
        4: { name: "poster", label: "Poster", labelSingular: "Poster" },
        5: { name: "geschenke", label: "Fotogeschenke", labelSingular: "Fotogeschenk" },
        6: { name: "kalender", label: "Echtfoto-Kalender", labelSingular: "Echtfoto-Kalender" },
        9: { name: "kalender_offset", label: "Offset-Kalender", labelSingular: "Offset-Kalender" },
        10: { name: "kalender", label: "Digitaldruck-Kalender", labelSingular: "Digitaldruck-Kalender" },
        15: { name: "kalender_express", label: "Express-Kalender", labelSingular: "Express-Kalender" },
    },
    ratios: {
        "2:3": { label: "2:3" },
        "3:4": { label: "3:4" },
        "1:1": { label: "1:1" },
        "panorama": { label: "panorama" }
    },
    orientation: {
         "Hochformat": { label: "Hochformat" },
         "Querformat": { label: "Querformat" },
         "quadratisch": { label: "Quadratformat" }
    },
    cat: {
        "tischkalender" : { label: "Tischkalender" },
        "wandkalender" : { label: "Wandkalender" },
        "tassen" : { label: "Tassen" },
        "postkarten" : { label: "Postkarten" },
        "speicherkarten" : { label: "Speicherkarten" }
    },
    mediaType: {
        "K12-14": { label: "Wandkalender Querformat", ratio: "1.41" },
        "K12-07": { label: "Wandkalender Hochformat", ratio: "0.71" },
        "K12-05": { label: "Wandkalender Skyscraper", ratio: "0.45" },
        "K12-10": { label: "Wandkalender Quadratformat", ratio: "1.0" },
        "K12-20": { label: "Wandkalender Panorama", ratio: "2.0"},
        "K24-05": { label: "Wandkalender Skyscraper doppelseitig", ratio: "0.5"},
        "K24-07": { label: "Wandkalender Hochformat doppelseitig", ratio: "0.71"},
        "K24-10": { label: "Wandkalender Quadratformat doppelseitig", ratio: "1.0"},
        "K24-20": { label: "Wandkalender Panorama doppelseitig", ratio: "2.0"},
        "TK12-14": { label: "Tischkalender Querformat", ratio: "1.41" },
        "TK24-14": { label: "Tischkalender Querformat", ratio: "1.41" },
        "TK12-20": { label: "Tischkalender DIN lang", ratio: "2.35" },
        "TK24-20": { label: "Tischkalender DIN lang doppelseitig", ratio: "2.35" },
        "TK12-10": { label: "Tischkalender Quadratformat", ratio: "1.0"},
        "TK24-10": { label: "Tischkalender Quadratformat doppelseitig", ratio: "1.0"},
        "KK-028": { label: "Küchenkalender", ratio: "0.28" },
        "BK-24": { label: "Bürokalender", ratio: "2.4" },
        "KH28-14": { label: "Klammerheftung doppelseitig", ratio: "1.41" },
        "KH12-14": { label: "Klammerheftung", ratio: "1.41" },
    },
    quantityMin: {
        "_translate_": "product.circulation"
    }

};

// Primärer Filter
// Es könnnen alle Filter verwendet werden (parameter "filter"), 
// die in ProductSelector.applyPrefilterItem() definiert wurden
// mit active=true eingestellte Filter sind voreingestellt aktiv
// Filter die nicht mit public=false gesetzt sind können vom Benutzer ein und ausgeschaltet werden

const preFilterDef = {
    filematch: {name: "passend zur Datei", filter: "filematch", active:true, public: false},
  //  offer: {name: "Angebote", filter: "offer"},
  //  offset: {name: "Offsetdruck" , filter: "printtype", values: ["offset"]},
  //  digital: {name: "Digitaldruck", filter: "printtype", values: ["digital"]}
};

/*
* Vorkonfigurierte Formulare
* Jeder Schlüssel beschreibt ein Formular in Form einer Liste
* von FormKit Elementen. Alle Elemente mit form:1 sind Elemente,
* die aktiv als Datenbankfilter eingesetzt werden. Alle anderen Elemente
* können beliebige FormKit Elemenzte sein.
*
* type: FormKit Elementtyp (z.B. "select", "radio", "radio-float", "tab", "dropgrid2" etc.)
* group: Gruppierungs- und Filterungsparameter. Alle Elemente mit dem gleichen group-Parameter gehören zu einer Gruppe und filtern die Datenbank anhand dieses Parameters.
* filter: Filtertyp, der in ProductSelector.applyFilterItem() definiert ist. Er bestimmt, wie die Auswahl des Elements die Datenbank filtert.
* label: Beschriftung des Elements im Formular
* display: "auto" (optional): Element wird nur angezeigt, wenn es für die aktuelle Produktauswahl relevant ist (z.B. Papieroptionen nur bei Fotoprodukten)
* settings: {class: "<CSS Klassenname>", "title": "<Titel für Selektorgruppe"} (optional): Zusätzliche Einstellungen, z.B. CSS-Klassen für die FormKit Elemente
* settings.sort: {by: "<Produkteigenschaft>", direction: "asc|desc", toStart: [], toEnd: []} (optional): Sortierung der verfügbaren Optionen
*/

const printTypes = {
    offset: {tag: "Offsetdruck", label: "Offsetdruck"},
    digital: {tag: "Digitaldruck", label: "Digitaldruck"},
    exposure: {tag: "Fotobelichtung", label: "Fotobelichtung"}
};

const layoutScheme = {

    legacy: [
         { form: 1, type: "select", group: "pgrId", filter: "column", label: "Produktgruppe" },
         { form: 1, type: "select", group: "orientation", filter: "tag", label: "Ausrichtung" },
         { form: 1, type: "radio-float", group: "surface", filter: "column", label: "Papier" },
            { form: 1, type: "select", group: "format", filter: "column", label: "Format", settings: { sort: { by: "widthMM", toEnd: ["A5 (21x15)","A5 (15x21)"] } } },
         { form: 1, type: "radio", filter: "final", group: "pid", label: "Ausführung" }
    ],
    compact: [
        { form: 1, type: "dropgrid2", group: "cat", filter: "cat", label: "Kategorie" },
        { form: 1, type: "select", group: "quantityMin", filter: "column", label: "Mindestmenge", display:"auto", "settings": { "class": "circulation" }},
        { form: 1, type: "select", group: "mediaType", filter: "column", label: "Seitenverhältnis" , display:"auto"},
        //{ form: 1, type: "tab", group: "orientation", filter: "tag", label: "Ausrichtung", display:"auto"},
        { form: 1, type: "select", group: "format", filter: "column", label: "Format", settings: { showPrintType: 1, sort: { by: "widthMM", toEnd: ["20x30", "30x45", "A5 (21x15)","A5 (15x21)"]}} },
        { form: 1, type: "select", group: "surface", filter: "column", label: "Papier", display:"auto", settings: { sort: { by: "surface"} } },
        { form: 1, type: "radio", filter: "final", group: "pid", label: "Ausführung" }
    ],
    standard: [
        { form: 1, type: "icon", group: "cat", filter: "cat", label: "Kategorie" },
        { form: 1, type: "radio", group: "quantityMin", filter: "column", label: "Mindestmenge", display:"auto", "settings": { "class": "circulation" }},
        { form: 1, type: "icon", group: "orientation", filter: "tag", label: "Ausrichtung", display:"auto"},
        { form: 1, type: "select", group: "format", filter: "column", label: "Format", settings: { sort: { by: "widthMM", toEnd: ["A5 (21x15)","A5 (15x21)"] } } },
        { form: 1, type: "icon", group: "surface", filter: "column", label: "Papier", display:"auto"},
        { form: 1, type: "radio", filter: "final", group: "pid", label: "Ausführung" }
    ]
};

// Bedingungen, die erfüllt sein müssen, damit eine Datei (media|image) zum 
// Produkt passt
// <beliebiger Index> : {
//         contenType:<media|image>,
//         productMatch: [    ** Liste von Bedingungen, die erfüllt sein müssen **
//             <media.property> : <product.property>.  ** beginnt product property mit ":", wird es als statischer wert (nach dem :) übernommen
//             <media.property> : {<match_function>:<arguments>}   ** match_function: between|lower|greater|or **
//         ]
// } 
const mediaConditionFilter = {
    media: {
        contentType:"media", 
        productMatch:[{type:{"or":["mediaType",":application/pdf"]}, module:"setup.condition.accept.modules", pages:{"between":["pageMin","pageMax"]}}]
        
    },
    image: {
        contentType:"image",
    }
};

const autoLayoutPgr = {

};

const autoLayoutCat = {
    //wandkalender: 'kalender',
    // tischkalender: 'kalender'
};

const layoutSlideshow = {
    
};

const mediaSelector = {
    default: {
        accept:{
            contentType:['media'],
            modules:['kalender','calendar','file']
        },
        browse: 'none'
    }
};

// Konfiguration fuer das Dateiauswahl-Menue im ProductSelector.
// "neu gestalten" kann je nach Selektor-Status unterschiedliche Aktionen anbieten.

const productSelectorUploadMenu = {
    menuItems: [{
                id: 'open-gallery',
                action: 'open-gallery',
                label: 'meine Kalender',
                byCategory: {
                    wandkalender: {
                        label: 'meine Kalender'
                    },
                    tischkalender: {
                        label: 'meine Kalender'
                    },
                    fotos: {
                        label: 'meine Bilder'
                    },
                    postkarten: {
                        label: 'meine Bilder'
                    },
                    poster: {
                        label: 'meine Bilder'
                    },
                    wandbilder: {
                        label: 'meine Bilder'
                    },
                    tassen: {
                        label: 'meine Bilder'
                    }
                }
    }],
    redesign: {
        label: 'neu gestalten',
        hideWhenUnavailable: true,
        whenNoSelection: true,
        defaultAction: {
            id: 'calendar-editor',
            action: 'calendar-editor',
            label: 'Kalender neu gestalten'
        },
        byCategory: {
            wandkalender: {
                id: 'calendar-editor',
                action: 'calendar-editor',
                label: 'Kalender neu gestalten'
            },
            tassen: {},
            fotos: {},
            postkarten: {},
            poster: {},
            wandbilder: {}
        }
    }
};
// Produkt-Optionen, die im Media-Objekt gespeichert werden
// Dies sind Produktoptionen, die nur dann eingeblendet werden, wenn wenn sie im Medienobjekt vorhanden sind.
// Sie können nur im Editor bearbeitet werden.
const mediaProductOptions = {
    "canvas_enlargement" : {}
};

// Zusätzliche Aktionen in der Galerie, gruppiert nach Ordner-OID.
const galleryFolderActions = {
    11: [{
        id: 'create-calendar',
        label: 'Kalender erstellen',
        icon: 'calendar',
        action: 'location',
        target: '/editor.js'
    }]
};

// Konfiguration fuer Zusatzinfos in UserOrderDetails Produktzeilen.
// Nur Keys, die hier definiert sind, werden aus Parameter=Wert-Daten angezeigt.
// Werte koennen optional auf lesbare Labels gemappt werden.
// Beispiel:
// color_mode: {
//     label: 'Farbmodus',
//     values: {
//         rgb: 'RGB',
//         cmyk: 'CMYK'
//     }
// }
const userOrderDetailsItemParameterDisplay = {
    binding_color: {
        label: 'Bindungsfarbe',
        values: {
            "black": "Bindung Schwarz",
            "white": "Bindung Weiß",
            "silver": "Bindung Silber"
        }
    },
    lastpage: {
        label: 'letzte Seite',
        values: {
            "inorder": "fortlaufend",
            "turned": "gedreht"
        }
    }
};

const previewMaps = {
    GA1: {
        id: 'GA1',
        renderMode: 'three-image',
        size: [910, 365],
        background: '/images/montageflaeche-tasse.png',
        map: [185, 65, 540, 230],
        three: {
           // model: '/assets/three/Cup2.glb',
           // materialName: 'Material.001'
            model: '/assets/three/Cup1_draco.glb',
            materialName: 'print_area',
            // Große Modelle können mit Draco komprimiert werden: gltf-pipeline -i Cup1.glb -o Cup1_draco.glb --draco.compressionLevel 10
            draco: true ,  
            // Nur in Spezialfaellen aktivieren (Performance + UV/Overlay-Risiko)
            useSubdivisionModifier: false,
            subdivisionLevels: 2,
            subdivisionPreserveEdges: true,
            subdivisionMaxTriangles: 80000,
            subdivisionExcludeMaterialNames: ['print_area']
        }
    },
    GA16: {
        id: 'GA16',
        renderMode: 'three-image',
        size: [910, 365],
        background: '/images/montageflaeche-tasse.png',
        map: [185, 65, 540, 230],
        three: {
            model: '/assets/three/Cup2.glb',
            materialName: 'Material.001'
        }
    },
    GA14: {
        id: 'GA14',
        renderMode: 'map2d',
        size: [560, 540],
        background: '/images/kissen.jpg',
        map: [65, 140, 430, 287]
    }
};

export { autoLayoutPgr as a, autoLayoutCat as b, layoutSlideshow as c, previewMaps as d, productSelectorUploadMenu as e, filterDef as f, mediaConditionFilter as g, mediaProductOptions as h, galleryFolderActions as i, imageResolutionLevels as j, previewResourceSizes as k, layoutScheme as l, mediaSelector as m, printTypes as n, preFilterDef as p, resolutionConfirmation as r, specialPriceDisplay as s, userOrderDetailsItemParameterDisplay as u };
